import { isNumber } from '@impuls-coach/util-is';
import { roundHalfUp } from '@impuls-coach/util-round';

export const calculateBmi = (
	weight: number = 0,
	height: number = 0,
	asDecimal: boolean = false,
	shouldRoundHalfUp: boolean = false
): number => {
	if (!weight || !height || !isNumber(weight) || !isNumber(height) || weight < 1 || height < 1) {
		return -1;
	}
	let value = weight / (((height / 100) * height) / 100);
	value = asDecimal ? parseFloat(`${value}`) : parseInt(`${value}`, 10);

	return shouldRoundHalfUp ? roundHalfUp(value) : value;
};

export const calculatedBmi = (
	weight: number = 0,
	height: number = 0,
	weightInput: number | string = 0,
	asDecimal: boolean = false,
	rhu: boolean = false
): number => {
	const weigthIpt: number = parseFloat(`${weightInput}`) || 0;
	if (!weigthIpt || weigthIpt <= 0) {
		return -1;
	}
	const newWeight: number = (weight || 0) - weigthIpt;
	return calculateBmi(newWeight, height, asDecimal, rhu);
};

export const formatBmi = (value?: number) => {
	if (typeof value !== 'number') {
		return '';
	}
	if (value <= 0) {
		return '';
	}
	return (Math.round(value * 10) / 10).toString();
};

export default {
	calculateBmi,
	calculatedBmi,
	formatBmi,
};
